import { render, staticRenderFns } from "./CategoriesSection.vue?vue&type=template&id=9a7536dc&scoped=true&"
import script from "./CategoriesSection.vue?vue&type=script&lang=ts&"
export * from "./CategoriesSection.vue?vue&type=script&lang=ts&"
import style0 from "./CategoriesSection.vue?vue&type=style&index=0&id=9a7536dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7536dc",
  null
  
)

export default component.exports